import api from './api';

const DashboardService = {
  getStats: async (params = {}) => {
    try {
      const response = await api.get('/dashboard/stats/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
      throw error;
    }
  }
};

export default DashboardService;
